import { useQuery } from '@tanstack/react-query';

import { currentAccountService } from '../services/currentAccount.service';

export const useCurrentAccount = (accountId: string | undefined) => {
  return useQuery({
    queryKey: ['current-account', accountId],
    queryFn: () => currentAccountService.getAccount(accountId!),
    enabled: !!accountId
  });
};
